import styled from 'styled-components';

export const DeleteButton = styled('button')`
  position: relative;
  padding: 0 12px;
  width: ${({ theme }) => theme.x4spacePx}px;
  height: ${({ theme }) => theme.x2spacePx}px;
  margin-top: -8px;
  > svg {
    position: absolute;
    left: 10px;
    top: 0px;
    width: 12px;
    height: 12px;
  }
`;

export const CurrentTransactionWrapper = styled.div`
  height: auto;
  margin-top: 15px;
  overflow: hidden;
`;

export const LoadingTextWrapper = styled.p`
  position: relative;
  padding: 1em 0;
  margin: 20px 0;
  text-align: center;
`;
